// Tone selects the file-tile palette. 'bubble' is the dark-ink scheme tuned for the
// user's light bubble; 'surface' drives colors off the theme ink vars so file tiles
// stay legible when an ASSISTANT message renders them directly on the surface. Image
// thumbnails are tone-agnostic — only the file-tile chrome changes.
export type AttachmentTone = 'bubble' | 'surface';

export function attachmentPalette(tone: AttachmentTone) {
  if (tone === 'surface') {
    return {
      fg: 'rgba(var(--ink-rgb), 0.92)',
      tileBg: 'rgba(var(--ink-rgb), 0.08)',
      tileBorder: 'none',
      badgeBg: 'rgba(var(--ink-rgb), 0.14)',
    };
  }
  return {
    fg: 'var(--sym-ink)',
    tileBg: 'rgba(var(--ink-rgb), 0.06)',
    tileBorder: 'none',
    badgeBg: 'rgba(var(--ink-rgb), 0.12)',
  };
}

export type AttachmentPalette = ReturnType<typeof attachmentPalette>;
